import { SearchFieldModel } from './search-field-model';
import { WhereClauseContactenator } from '../enums/where-clause-contactenator-enum';

export class SearchModel {
    public SearchFields: SearchFieldModel[];
    public WhereClauseContactenator: WhereClauseContactenator;
}
